var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "f7-page",
    {
      staticClass: "no-swipeback",
      attrs: { "login-screen": "", id: "login" },
      on: { "page:reinit": function ($event) {} },
    },
    [
      _c(
        "div",
        { staticClass: "body" },
        [
          _c("b-row", { staticClass: "h-100" }, [
            _c("div", { staticClass: "position-absolute welcome-text-login" }, [
              _c(
                "h1",
                {
                  staticClass: "d-block text-center text-white",
                  staticStyle: { "font-size": "3rem !important" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("Homepage.connect_toolbox")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "loginPanel loginHeight" }, [
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "panel-heading ajust text-center mb-2rem" },
                    [
                      _c("b-col", { attrs: { cols: "2" } }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-2", attrs: { cols: "8" } },
                        [
                          _c(
                            "span",
                            { staticClass: "navbar-brand mr-0 w-80" },
                            [
                              _c("img", {
                                staticClass: "heritage largescreen w-100",
                                attrs: {
                                  src: _vm.imgVarsLong,
                                  alt: "DealPrudence",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-0", attrs: { cols: "2" } },
                        [
                          !_vm.flagTOOLBOX
                            ? _c(
                                "b-dropdown",
                                {
                                  staticClass: "no-back",
                                  attrs: {
                                    left: "",
                                    "toggle-class": "border-0 m-md-2 z-5",
                                    variant: "light",
                                  },
                                  model: {
                                    value: _vm.language,
                                    callback: function ($$v) {
                                      _vm.language = $$v
                                    },
                                    expression: "language",
                                  },
                                },
                                [
                                  _c("template", { slot: "button-content" }, [
                                    _vm.language === "FR"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagFR,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.language === "EN"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagEN,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.language === "GB"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagEN,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.language === "DE"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagDE,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.language === "IT"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagIT,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.language === "ES"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagES,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.language === "PT"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: {
                                            src: _vm.logoFlagPT,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("span", {}, [
                                      _vm._v(_vm._s(_vm.labelLanguage)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.langOptions, function (option) {
                                    return _c(
                                      "b-dropdown-item",
                                      {
                                        key: option.value,
                                        staticClass: "dropdown-item-web-header",
                                        on: {
                                          click: function ($event) {
                                            return _vm.languageCountry(
                                              option.value
                                            )
                                          },
                                        },
                                      },
                                      [
                                        option.value === "FR"
                                          ? _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagFR,
                                                alt: "",
                                              },
                                            })
                                          : option.value === "GB"
                                          ? _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagEN,
                                                alt: "",
                                              },
                                            })
                                          : option.value === "DE"
                                          ? _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagDE,
                                                alt: "",
                                              },
                                            })
                                          : option.value === "IT"
                                          ? _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagIT,
                                                alt: "",
                                              },
                                            })
                                          : option.value === "ES"
                                          ? _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagES,
                                                alt: "",
                                              },
                                            })
                                          : option.value === "PT"
                                          ? _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagPT,
                                                alt: "",
                                              },
                                            })
                                          : _c("img", {
                                              staticClass: "flag-nav",
                                              attrs: {
                                                src: _vm.logoFlagEN,
                                                alt: "",
                                              },
                                            }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(option.text)),
                                        ]),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.mode === "confirmEmail"
                    ? _c(
                        "div",
                        {
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.registerUser()
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Login",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.eml_adrs"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.LoginError,
                                      specificMessage:
                                        _vm.credentials.LoginErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Login,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Login", $$v)
                                      },
                                      expression: "credentials.Login",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Token",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.login_token"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.TokenError,
                                      specificMessage:
                                        _vm.credentials.TokenErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Token,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Token", $$v)
                                      },
                                      expression: "credentials.Token",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mb-2" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex",
                                  attrs: { cols: "10", offset: "2" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.rgpd,
                                            expression: "rgpd",
                                          },
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "checkbox-rgpd",
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          value: 1,
                                          checked: Array.isArray(_vm.rgpd)
                                            ? _vm._i(_vm.rgpd, 1) > -1
                                            : _vm.rgpd,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.rgpd,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = 1,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.rgpd = $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.rgpd = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.rgpd = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          on: { click: _vm.clickedRgpd },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("loginPage.accept_rgpd")
                                              )
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-link font-weight-normal pl-2",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getUri(
                                                    _vm.links.rgpd_mandatory
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.read"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "d-flex",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.termsConditions,
                                            expression: "termsConditions",
                                          },
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "checkbox-terms-conditions",
                                          type: "checkbox",
                                          "unchecked-value": 0,
                                        },
                                        domProps: {
                                          value: 1,
                                          checked: Array.isArray(
                                            _vm.termsConditions
                                          )
                                            ? _vm._i(_vm.termsConditions, 1) >
                                              -1
                                            : _vm.termsConditions,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.termsConditions,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = 1,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.termsConditions =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.termsConditions = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.termsConditions = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "custom-control-label",
                                          on: { click: _vm.clickedTerms },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("loginPage.accept_cgu")
                                              )
                                            ),
                                          ]),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-link font-weight-normal pl-2",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getUri(
                                                    _vm.links
                                                      .conditions_mandatory
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("common.read"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "register"
                    ? _c(
                        "div",
                        {
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.registerUser()
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Login",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.eml_adrs"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.LoginError,
                                      specificMessage:
                                        _vm.credentials.LoginErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Login,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Login", $$v)
                                      },
                                      expression: "credentials.Login",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "label",
                                      { attrs: { for: "password" } },
                                      [_vm._v(_vm._s(_vm.$t("common.pwd")))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "d-flex" }, [
                                      _vm.credentials.PasswordFieldType ===
                                      "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Password,
                                                expression:
                                                  "credentials.Password",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.PasswordError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.credentials.Password
                                              )
                                                ? _vm._i(
                                                    _vm.credentials.Password,
                                                    null
                                                  ) > -1
                                                : _vm.credentials.Password,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.credentials.Password,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "Password",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "Password",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "Password",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          })
                                        : _vm.credentials.PasswordFieldType ===
                                          "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Password,
                                                expression:
                                                  "credentials.Password",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.PasswordError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "radio",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.credentials.Password,
                                                null
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.credentials,
                                                  "Password",
                                                  null
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Password,
                                                expression:
                                                  "credentials.Password",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.PasswordError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: _vm.credentials
                                                .PasswordFieldType,
                                            },
                                            domProps: {
                                              value: _vm.credentials.Password,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "Password",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "icon icon-password mt-2 pt-1",
                                        class: [
                                          _vm.isPasswordFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                        on: {
                                          click: _vm.togglePasswordVisibility,
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _vm.credentials.PasswordError
                                      ? _c(
                                          "div",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.credentials
                                                    .PasswordErrorMessage
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "label",
                                      { attrs: { for: "password" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.conf_pwd"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "d-flex" }, [
                                      _vm.credentials
                                        .PasswordRepeatFieldType === "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                expression:
                                                  "credentials.PasswordRepeat",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials
                                                .PasswordRepeatError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.credentials.PasswordRepeat
                                              )
                                                ? _vm._i(
                                                    _vm.credentials
                                                      .PasswordRepeat,
                                                    null
                                                  ) > -1
                                                : _vm.credentials
                                                    .PasswordRepeat,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.credentials
                                                      .PasswordRepeat,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "PasswordRepeat",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "PasswordRepeat",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "PasswordRepeat",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          })
                                        : _vm.credentials
                                            .PasswordRepeatFieldType === "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                expression:
                                                  "credentials.PasswordRepeat",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials
                                                .PasswordRepeatError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "radio",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.credentials.PasswordRepeat,
                                                null
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.credentials,
                                                  "PasswordRepeat",
                                                  null
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                expression:
                                                  "credentials.PasswordRepeat",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials
                                                .PasswordRepeatError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: _vm.credentials
                                                .PasswordRepeatFieldType,
                                            },
                                            domProps: {
                                              value:
                                                _vm.credentials.PasswordRepeat,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "PasswordRepeat",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "icon icon-password mt-2 pt-1",
                                        class: [
                                          _vm.isPasswordRepeatFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                        on: {
                                          click:
                                            _vm.togglePasswordRepeatVisibility,
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _vm.credentials.PasswordRepeatError
                                      ? _c(
                                          "div",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.credentials
                                                    .PasswordRepeatErrorMessage
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.mode === "totp"
                    ? _c(
                        "div",
                        {
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.registerUser()
                            },
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      id: "Login",
                                      disabled: "",
                                      inputType: "text",
                                      inputLabel: _vm.$t("common.eml_adrs"),
                                      inputClass: "inputLogin",
                                      specificErrorIndicator:
                                        _vm.credentials.LoginError,
                                      specificMessage:
                                        _vm.credentials.LoginErrorMessage,
                                    },
                                    model: {
                                      value: _vm.credentials.Login,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.credentials, "Login", $$v)
                                      },
                                      expression: "credentials.Login",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "8", offset: "3" } },
                                [
                                  _vm.qrCodeDataUrl
                                    ? _c("div", [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.qrCodeDataUrl,
                                            alt: "QR Code",
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { cols: "8", offset: "2" },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "label",
                                      { attrs: { for: "token TOTP" } },
                                      [_vm._v(_vm._s(_vm.$t("common.totp")))]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "d-flex" }, [
                                      _vm.credentials.PasswordFieldType ===
                                      "checkbox"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Totp,
                                                expression: "credentials.Totp",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.TotpError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.credentials.Totp
                                              )
                                                ? _vm._i(
                                                    _vm.credentials.Totp,
                                                    null
                                                  ) > -1
                                                : _vm.credentials.Totp,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a = _vm.credentials.Totp,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "Totp",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.credentials,
                                                        "Totp",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "Totp",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          })
                                        : _vm.credentials.PasswordFieldType ===
                                          "radio"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Totp,
                                                expression: "credentials.Totp",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.TotpError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: "radio",
                                            },
                                            domProps: {
                                              checked: _vm._q(
                                                _vm.credentials.Totp,
                                                null
                                              ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.$set(
                                                  _vm.credentials,
                                                  "Totp",
                                                  null
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.credentials.Totp,
                                                expression: "credentials.Totp",
                                              },
                                            ],
                                            staticClass:
                                              "form-control inputAccordionForm inputLogin h-30px",
                                            class: [
                                              _vm.credentials.TotpError
                                                ? "errorBorder"
                                                : "",
                                            ],
                                            attrs: {
                                              id: "password",
                                              type: _vm.credentials
                                                .PasswordFieldType,
                                            },
                                            domProps: {
                                              value: _vm.credentials.Totp,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "Totp",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "icon icon-password mt-2 pt-1",
                                        class: [
                                          _vm.isPasswordFieldHidden
                                            ? "fa-duotone fa-eye"
                                            : "fa-duotone fa-eye-slash",
                                        ],
                                        on: {
                                          click: _vm.togglePasswordVisibility,
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _vm.credentials.TotpError
                                      ? _c(
                                          "div",
                                          { staticClass: "text-danger" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.credentials
                                                    .PasswordErrorMessage
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.mode === "confirmEmailSent"
                    ? _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("loginPage.email_confirmation_mail_sent")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  ["confirmEmail", "register", "totp"].includes(_vm.mode)
                    ? _c(
                        "b-row",
                        { staticClass: "loginButtons" },
                        [
                          _c(
                            "b-col",
                            { attrs: { cols: "8", offset: "2" } },
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "primary",
                                    size: "lg",
                                    id: "submit-btn",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.registerUser()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("loginPage.create_account")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "footer",
                    { staticClass: "pt-3 pb-1" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "xs-12 text-center" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center",
                                },
                                [
                                  _c("img", {
                                    staticClass: "logoStreammind",
                                    attrs: {
                                      alt: "Streammind",
                                      src: _vm.logoStreammind,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.copyright"))
                                    ),
                                  ]),
                                  _vm._v(" \n                  "),
                                  _c("span", [_vm._v(_vm._s(_vm.version))]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }